module.exports = __webpack_public_path__ + "img/pressure_blue.08a6bc30.svg";